class Action {
    constructor(age, name, text, effect, prerequisite)
    {
        this.age = age;
        this.name = name;
        this.text = text;
        this.effect = effect;
        this.prerequisite = prerequisite;
    }

    GetAge() {
        return this.age;
    }

    GetName() {
        return this.name;
    }

    GetText() {
        return this.text;
    }
}

module.exports = Action;